import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Layout } from "./components/layout/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Solution from "./pages/Solution";
import Realisations from "./pages/Realisations";
import About from "./pages/About";
import Support from "./pages/Support";
import Devis from "./pages/Devis";
import Contact from "./pages/Contact";
import MentionsLegales from "./pages/MentionsLegales";
import Actus from "./pages/Actus";
import Missions from "./pages/Missions";
import MissionDetail from "./pages/MissionDetail";
import ActuDetail from "./pages/ActuDetail";
import { lazy, Suspense } from "react";
import { AuthProvider, RequireAdmin } from "./lib/auth";

const AdminLogin = lazy(() => import("./pages/admin/AdminLogin"));
const AdminForgot = lazy(() => import("./pages/admin/AdminForgot"));
const AdminReset = lazy(() => import("./pages/admin/AdminReset"));
const AdminPassword = lazy(() => import("./pages/admin/AdminPassword"));
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard"));
const AdminEditor = lazy(() => import("./pages/admin/AdminEditor"));
const AdminPreview = lazy(() => import("./pages/admin/AdminPreview"));
const AdminShell = lazy(() => import("./components/admin/AdminShell").then((m) => ({ default: m.AdminShell })));

const AdminAuth = () => (
  <AuthProvider>
    <Suspense fallback={<div className="min-h-screen bg-paper" />}>
      <Outlet />
    </Suspense>
  </AuthProvider>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="services/:slug" element={<ServiceDetail />} />
          <Route path="solutions/:slug" element={<Solution />} />
          <Route path="missions" element={<Missions />} />
          <Route path="missions/:slug" element={<MissionDetail />} />
          <Route path="realisations" element={<Navigate to="/realisations/references" replace />} />
          <Route path="realisations/references" element={<Realisations />} />
          <Route path="realisations/actus" element={<Actus />} />
          <Route path="actualites/:slug" element={<ActuDetail />} />
          <Route path="a-propos" element={<About />} />
          <Route path="support" element={<Support />} />
          <Route path="devis" element={<Devis />} />
          <Route path="contact" element={<Contact />} />
          <Route path="mentions-legales" element={<MentionsLegales />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
        <Route path="admin" element={<AdminAuth />}>
          <Route path="connexion" element={<AdminLogin />} />
          <Route path="mot-de-passe-oublie" element={<AdminForgot />} />
          <Route path="reinitialiser" element={<AdminReset />} />
          <Route element={<RequireAdmin />}>
            <Route element={<AdminShell />}>
              <Route index element={<AdminDashboard />} />
              <Route path="mot-de-passe" element={<AdminPassword />} />
              <Route path="actus/nouvelle" element={<AdminEditor />} />
              <Route path="actus/:id" element={<AdminEditor />} />
            </Route>
            <Route element={<Layout />}>
              <Route path="apercu/:id" element={<AdminPreview />} />
            </Route>
          </Route>
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
